"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putValidateCertificateVersion = exports.putCertificateVersion = exports.postCertificateVersion = exports.postCertificate = exports.putCertificate = exports.getCertificate = exports.getCertificates = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var certificatesPath = root_1.identityAuthorized + '/certificates/';

var getCertificates = function getCertificates(authentication, queryParameters) {
  return common_1.get(authentication, certificatesPath, queryParameters);
};

exports.getCertificates = getCertificates;

var getCertificate = function getCertificate(authentication, id) {
  return common_1.get(authentication, certificatesPath + id);
};

exports.getCertificate = getCertificate;

var putCertificate = function putCertificate(authentication, certificate) {
  return common_1.put(authentication, certificatesPath + certificate.id, certificate);
};

exports.putCertificate = putCertificate;

var postCertificate = function postCertificate(authentication, certificate) {
  return common_1.post(authentication, certificatesPath, certificate);
};

exports.postCertificate = postCertificate;

var postCertificateVersion = function postCertificateVersion(authentication, id, certificateVersion) {
  return common_1.post(authentication, certificatesPath + id + '/versions/', certificateVersion);
};

exports.postCertificateVersion = postCertificateVersion;

var putCertificateVersion = function putCertificateVersion(authentication, id, certificateVersion) {
  return common_1.put(authentication, certificatesPath + id + '/versions/', certificateVersion);
};

exports.putCertificateVersion = putCertificateVersion;

var putValidateCertificateVersion = function putValidateCertificateVersion(authentication, id, versionId, useDnsChallenge) {
  return common_1.put(authentication, certificatesPath + id + '/versions/' + versionId + '/validate', {
    useDnsChallenge: useDnsChallenge
  });
};

exports.putValidateCertificateVersion = putValidateCertificateVersion;